<!-- Webhook Form -->
<ng-template [ngIf]="loaded">
  <div class="row">
    <div class="col-8">
      <h5>Add/Edit Webhook</h5>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <button class="btn btn-primary float-right" (click)="save()">Save</button>
      <button class="btn btn-primary mx-2 float-right" (click)="cancel()">Cancel</button>
      <button *ngIf="!isAdd" class="btn btn-danger float-right mr-4" (click)="delete()">Delete</button>
    </div>
  </div>

  <div class="row">
    <div class="col-12 pt-2">
      <app-srs-multi-element-widget [config]="formConfig"></app-srs-multi-element-widget>
    </div>
  </div>
</ng-template>
